@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.unspecified-service {
  color: @fulfillment-planner--requested-shipping-unspecified-service--text-color;
  font-style: italic;
}

.specified-service {
  color: @fulfillment-planner--requested-shipping-specified-service--text-color;
  font-weight: @bold;
  word-break: break-word;
}

.service-map-button {
  margin: 0 0 0 5px;
}

.requested-service {
  display: flex;
  align-items: center;
  min-height: 25px;
}
